import { FunctionComponent } from "react";
import { useFonts } from "expo-font";

export const fontMap = {
  "Inter-Regular": require("../../assets/Inter/Inter-Regular.ttf"),
  "Inter-ExtraBold": require("../../assets/Inter/Inter-ExtraBold.ttf"),
  "Inter-SemiBold": require("../../assets/Inter/Inter-SemiBold.ttf"),
  "Inter-Medium": require("../../assets/Inter/Inter-Medium.ttf"),
  "Inter-Light": require("../../assets/Inter/Inter-Light.ttf"),
  "SF-Mono-Light": require("../../assets/SF-Mono-Light.otf"),
  "Caveat-SemiBold": require("../../assets/Caveat-SemiBold.ttf"),
  StoresprintIcons: require("arkh/src/cross-platform/AHIcon/fonts/StoresprintIcons.ttf"),
};

export const AHFontLoader: FunctionComponent<any> = (props) => {
  const [fontLoaded] = useFonts(fontMap);

  if (fontLoaded) {
    return props.children ? props.children : null;
  }
  return null;
};
